export enum ContactType {
  CLIENT = "CLIENT",
  PROSPECT = "PROSPECT",
  VENDOR = "VENDOR",
  WORKFORCE = "WORKFORCE",
  OWNER = "OWNER",
  JOB_APPLICANT = "JOB_APPLICANT",
  OTHER = "OTHER",
}

export interface IContactPhoneNumber {
  number: string;
  label?: string | null;
  isPrimary?: boolean;
}

export interface IContact {
  uid: string;
  companyId?: number;
  phoneNumber?: string;
  phoneNumbers?: IContactPhoneNumber[];
  name?: string;
  lastName?: string | null;
  type?: ContactType;
  email?: string | null;
  notes?: string | null;
}

export interface ICreateContact {
  companyId: number;
  contactUid?: string;
  phoneNumbers: IContactPhoneNumber[];
  name: string;
  lastName: string | null;
  type: ContactType;
  email: string | null;
  notes: string | null;
}

export interface IUpdateContact {
  uid: string;
  companyId?: number;
  phoneNumbers?: IContactPhoneNumber[];
  name?: string;
  lastName?: string | null;
  type?: ContactType;
  email?: string | null;
  notes?: string | null;
}

export interface IGetContactsResponse {
  data: IContact[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}
